'use strict';

// Constructor
var SectionLandingSubnavigation = function() {
    $('.block-subnavigation-block .spf-image-outer').matchHeight();
    $('.block-subnavigation-block .spf-article-box').matchHeight();

    //load only 8 submenu by default
    //and show load more button
    $('ul.menu.menu__top').each(function() {
        $(this).children(".menu-item").slice(8).hide();

        if($(this).children(".menu-item").length > 8 ){
            $('ul.menu.menu__top').after('<a href="#" class="see-all-services">See all</a><a href="#" class="see-less-services">See less</a>');
            $(".see-less-services").hide();
          }
    });

    //click see all services to see more
    $(".see-all-services").click(function() {
        event.preventDefault();
        $('ul.menu.menu__top').each(function() {
            $(this).children().slideDown('slow');
        });
        $(".see-all-services").hide();
        $(".see-less-services").show();
    });

    //click see less services to see less
    $(".see-less-services").click(function() {
        event.preventDefault();
        $("ul.menu.menu__top").children(".menu-item").slice(8).slideUp('slow');
        $(".see-less-services").hide();
        $(".see-all-services").show();
    });

};

module.exports = SectionLandingSubnavigation;
